
export default {
  props: {
    url: { type: String, default: '' },
  },
  computed: {
    socialUrl() {
      return 'https://www.athlyzer.com' + this.$props.url
    },
  },
}
